module.exports = __webpack_public_path__ + "static/media/quidditch.f748ef78.svg";